import { CalendarPlus, ClipboardList, Plus, UserPlus } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSession } from '@/features/auth';
import { Button } from '@/shared/ui/Button';
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/ui/Popover';
import { cn } from '@/shared/lib/utils';

const itemClass =
  'flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-left text-[13px] text-ink-700 transition hover:bg-surface-100';

/**
 * Single primary Create control with role-softened quick actions.
 */
export function HeaderCreateMenu(): JSX.Element {
  const [open, setOpen] = useState(false);
  const { user } = useSession();
  const role = user?.role ?? '';
  const isDoctor = role === 'doctor';

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="default"
          size="sm"
          className="h-9 w-9 gap-0 rounded-xl p-0 font-semibold sm:w-auto sm:gap-1.5 sm:px-3"
          aria-haspopup="menu"
          aria-expanded={open}
          aria-label="Create"
        >
          <Plus className="size-3.5" aria-hidden />
          <span className="hidden sm:inline">Create</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-56 p-1.5" role="menu" sideOffset={8}>
        <Link
          to="/appointments/new"
          className={itemClass}
          role="menuitem"
          onClick={() => setOpen(false)}
        >
          <CalendarPlus className="size-4 shrink-0 text-ink-500" aria-hidden />
          New appointment
        </Link>
        {!isDoctor ? (
          <Link
            to="/patients/new"
            className={itemClass}
            role="menuitem"
            onClick={() => setOpen(false)}
          >
            <UserPlus className="size-4 shrink-0 text-ink-500" aria-hidden />
            New patient
          </Link>
        ) : (
          <Link
            to="/appointments/waiting-room"
            className={itemClass}
            role="menuitem"
            onClick={() => setOpen(false)}
          >
            <ClipboardList className="size-4 shrink-0 text-ink-500" aria-hidden />
            Waiting room
          </Link>
        )}
        <p className={cn('px-3 pb-1 pt-2 text-[11px] text-ink-500')}>
          {isDoctor ? 'Floor shortcuts for chairside work' : 'Common front-desk tasks'}
        </p>
      </PopoverContent>
    </Popover>
  );
}
